(function(){
'use strict';

scFundraisingTeamModelFactory.$inject = ["$http", "$q", "$state", "scObjectModel", "scPreflight", "scCloneDeep", "scMembersService", "scPageAccessService", "scFundraisingTeamDefaults", "scFundraisingTeamPostsDemo", "scFundraisingPageDemo", "scCampaignsService"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @ngDoc factory
 * @name scFundraisingTeamModel
 *
 * @description
 * A campaign constructor with some common
 * prototype methods.
 */

function scFundraisingTeamModelFactory($http, $q, $state, scObjectModel, scPreflight, scCloneDeep, scMembersService, scPageAccessService, scFundraisingTeamDefaults, scFundraisingTeamPostsDemo, scFundraisingPageDemo, scCampaignsService) {
  var checkDashboardAccess = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pageType) {
      var teamLead, currentMember, isOwner;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              teamLead = _.get(this, 'current.team_lead_id', false);
              currentMember = _.get(scMembersService, 'active.current.id', null);
              _context.t0 = currentMember && teamLead == currentMember;

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return scPageAccessService.checkPageAdminAccess(pageType);

            case 6:
              _context.t0 = _context.sent;

            case 7:
              isOwner = _context.t0;

              if (!isOwner) {
                _context.next = 10;
                break;
              }

              return _context.abrupt('return', $q.resolve(true));

            case 10:
              return _context.abrupt('return', $q.resolve(false));

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function checkDashboardAccess(_x2) {
      return _ref.apply(this, arguments);
    };
  }();

  function scFundraisingTeamModel(data, demo) {
    scObjectModel.call(this);

    this.isNew = !demo && !data;
    this.isDemo = demo || !data;

    this.current = scCloneDeep(data || { goal: null });
    this.defaults = scCloneDeep(scFundraisingTeamDefaults);
    this.isExample = false;
    this.saved = scCloneDeep(data || { goal: null });
    this.type = 'fundraising-teams';
  }

  var model = scFundraisingTeamModel;

  // Constructor
  model.prototype = _.create(scObjectModel.prototype, {
    constructor: scFundraisingTeamModel
  });

  // Methods
  model.prototype.create = create;
  model.prototype.createPost = createPost;
  model.prototype.getCaptain = getCaptain;
  model.prototype.getFundraisers = getFundraisers;
  model.prototype.getParentTeam = getParentTeam;
  model.prototype.getPosts = getPosts;
  model.prototype.getStory = getStory;
  model.prototype.updateGroup = updateGroup;
  model.prototype.getSubteams = getSubteams;
  model.prototype.checkDashboardAccess = checkDashboardAccess;
  model.prototype.refreshData = refreshData;
  model.prototype.getSupporterCounts = getSupporterCounts;
  model.prototype.registerObserverCallback = registerObserverCallback;

  var observerCallbacks = [];

  return scFundraisingTeamModel;

  /* ---------------------------------------------------------------- *
   * Implementation
   * ---------------------------------------------------------------- */

  // public method, register an observer. Called when you need to watch for team
  // changes within an isolate scope to avoid super complex $watch patterns
  function registerObserverCallback(callback) {
    observerCallbacks.push(callback);
  }

  // call this below when you know the team has been changed
  function notifyObservers(current) {
    angular.forEach(observerCallbacks, function (callback) {
      callback(current);
    });
  }

  function getCaptain() {
    if (this.isNew || this.isExample || !this.current.team_lead_id) {
      return $q.resolve({ data: scMembersService.active.current });
    }
    return $http({
      url: '/frs-api/members/' + this.current.team_lead_id,
      method: 'GET'
    });
  }

  function updateGroup() {
    var _this = this;

    var changedKeys = this.mysqlDiff(),
        data = {};

    _.forEach(changedKeys, function (key) {
      data[key] = _this.current[key];
    });

    return scPreflight.prepare(data).then(function (payload) {
      return $http({
        method: 'PUT',
        url: '/frs-api/fundraising-team-group/' + _this.current.id,
        data: payload,
        loadingScope: true
      });
    }).then(function (response) {
      _this.saved = scCloneDeep(response.data);
      _.merge(_this.current, scCloneDeep(response.data));
      return _this.refreshData();
    });
  }

  function getPosts() {
    var memberId = _.get(scMembersService, 'active.current.id', null);

    if (this.isNew) {
      return $q.resolve(null);
    } else if (this.isDemo) {
      return $q.resolve({ data: scFundraisingTeamPostsDemo(this.current.id) });
    }
    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-teams/' + this.current.id + '/updates',
      params: {
        member_id: memberId
      }
    });
  }

  function getFundraisers(query) {
    if (this.isDemo) {
      return $q.resolve({
        data: [scFundraisingPageDemo()]
      });
    }
    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-teams/' + this.current.id + '/fundraising-pages',
      params: query
    }).then(function (result) {
      return result;
    });
  }

  function getSubteams(query) {
    if (this.isDemo) {
      return $q.resolve({
        data: [scFundraisingPageDemo()]
      });
    }
    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-teams/' + this.current.id + '/subteams',
      params: query
    }).then(function (result) {
      return result;
    });
  }

  function create(campaignId) {
    var _this2 = this;

    var optIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var postData = scCloneDeep(this.current);
    if (scCampaignsService.active.multiCurrencyDisabled() || postData.raw_goal) {
      delete postData.raw_currency_code;
    } else {
      postData.raw_goal = postData.goal;
      delete postData.goal;
    }

    if (optIn.opted_in != null && optIn.opt_in_wording != null) {
      postData.opted_in = optIn.opted_in;
      postData.opt_in_wording = optIn.opt_in_wording;
    }

    postData.admin_created = !!$state.includes('admin.manage.campaign.fundraising-team.new');

    return $http({
      url: '/frs-api/campaign/' + campaignId + '/fundraising-teams',
      method: 'POST',
      data: postData
    }).then(function (response) {
      _this2.current = scCloneDeep(response.data);
      _this2.saved = scCloneDeep(response.data);
      return $http({
        url: '/frs-api/members/' + response.data.team_lead_id
      });
    }).then(function (response) {
      _this2.current.team_lead = response.data;
      _this2.saved.team_lead = response.data;
      return { data: _this2.current };
    });
  }

  function getStory() {
    var memberId = _.get(scMembersService, 'active.current.id', null);

    if (this.isNew && !this.current.id) {
      return $q.resolve(null);
    } else if (this.isDemo) {
      return $q.resolve({ data: scFundraisingTeamPostsDemo(this.current.id) });
    }
    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-teams/' + this.current.id + '/stories',
      params: {
        member_id: memberId
      }
    });
  }

  function createPost(post) {
    return $http({
      method: 'POST',
      url: '/frs-api/fundraising-teams/' + this.current.id + '/updates',
      data: post
    });
  }

  function getParentTeam(query) {
    return $http({
      url: '/frs-api/fundraising-teams/' + this.current.parent_id,
      method: 'GET',
      params: query
    });
  }

  function refreshData() {
    var _this3 = this;

    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-teams/' + this.current.id + '?aggregates=true'
    }).then(function (response) {
      var updateableData = ['average_donation', 'goal', 'raw_goal', 'raw_currency_code', 'largest_donation', 'net_credit_balance', 'percent_to_goal', 'total_donations', 'total_donors', 'total_fundraisers', 'total_raised'];
      var updatedData = _.pick(response.data, updateableData);
      _.assign(_this3.current, updatedData);
      notifyObservers(_this3.current);
      return response;
    });
  }

  function getSupporterCounts() {
    var counts = {
      fundraiserCount: 0,
      subteams: 0,
      childPages: 0
    };

    var promises = [this.getSubteams(), this.getFundraisers()];

    return $q.all(promises).then(function (response) {
      counts.subteams = _.get(response[0], 'data.total', 0);
      counts.fundraiserCount = response[1].data.total;
      counts.childPages = counts.fundraiserCount + counts.subteams;
      return counts;
    });
  }
}

angular.module('classy').factory('scFundraisingTeamModel', scFundraisingTeamModelFactory);
})();